import React, { useRef, useEffect } from "react"
import styled from "styled-components"
import { motion, useAnimation } from "framer-motion"
import { useInView } from 'react-intersection-observer';
import Tabs from 'components/common/tabs'

import ContentWrapper from "styles/contentWrapper"

const StyledSection = styled.section`
  width: 100%;
  height: auto;
  background: ${({ theme }) => theme.colors.white};
  padding: 3rem 0;
  background: linear-gradient(
  357.83deg
  ,rgba(0,207,225,0) 1.57%,rgba(0,207,225,.06) 40.64%,rgba(255,255,255,.02) 99.79%);
      mix-blend-mode: normal;
`

const StyledContentWrapper = styled(ContentWrapper)`
  && {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-right: 0;
    padding-left: 0;
/*     background-image: url(${spot1}), url(${spot2}), url(${spot3});
    background-size: 16rem 22.5rem, 1.5rem 2rem, 2.55rem 2.55rem;
    background-position: 5% 45%, 5% 27%, 98% 98%;
    background-repeat: no-repeat; */
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
      padding-right: 2.5rem;
      padding-left: 2.5rem;
    }
    .section-title {
      max-width: 50rem;
      margin: auto;
      margin-bottom: 1rem;
    }
    .section-subtitle {
      text-align: center;
      margin-bottom: 2rem;
      margin-top: 0;
      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        padding-right: 0;
        padding-left: 0;
      }
    }
    .tabs-wrapper {
      .tabs {
        max-width: 60rem;
        margin: auto;
        .tab-list {
          justify-content: center;
          margin-top: 1.5rem;
          .tab-list-item:first-of-type {
            margin-left: 0;
          }
          .tab-list-item.tab-list-active {
            color: ${({ theme }) => theme.colors.secondary};
            &:before {
              background-color: ${({ theme }) => theme.colors.secondary};
            }
          }
          .tab-list-item:hover {
            &:before {
              background-color: ${({ theme }) => theme.colors.secondary};
            }
          }
        }
      }
    }
    .corporates-image {
      width: 100%;
      height: auto;
    }
  }
`

const Pipeline = ({  }) => {
  const { ref, inView, entry } = useInView({threshold: 0});
  const controls = useAnimation()
  if (inView) controls.start({ opacity: 1, y: 0 })

  return (
    <StyledSection id="layers">
      <StyledContentWrapper>
        <h2 className="section-title">The ultimate Talent Data pipeline</h2>
        <div className="section-subtitle">Make Data and Connectivity your competitive advantage</div>
        <motion.div
            ref={ref}
            initial={{ opacity: 0, y: 20 }}
            animate={controls}
            className="tabs-wrapper"
          >
            <Tabs minHeight={"33rem"}> 
              <div label="WITH HRFLOW.AI"> 
                <img
                  alt="Corporate image flow"
                  className="corporates-image"
                  src="https://hrflow-ai.imgix.net/corporate.svg"
                  width="984"
                  height="552.47"
                />
              </div> 
              <div label="WITHOUT HRFLOW.AI"> 
              <img
                alt="Corporate image schema"
                className="corporates-image"
                src="https://hrflow-ai.imgix.net/corporate2.svg"
                width="984"
                height="552.47"
              />
              </div>  
            </Tabs> 
          </motion.div>
      </StyledContentWrapper>
    </StyledSection>
  )
}

export default Pipeline
